import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle, Stat } from "@/components/app/ui";
import { api } from "@/lib/api";

const Chart = ({ title, data, x, y, color }) => (
  <div className="card-box p-5 h-64"><h3 className="text-sm font-semibold mb-3">{title}</h3>
    <ResponsiveContainer width="100%" height="85%"><BarChart data={data}><XAxis dataKey={x} fontSize={10} /><YAxis fontSize={10} allowDecimals={false} /><Tooltip /><Bar dataKey={y} fill={color} radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>
  </div>
);

export default function AdminReports() {
  const [r, setR] = useState(null);
  const [logs, setLogs] = useState([]);
  const [f, setF] = useState({ action: "", email: "" });
  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)); }, []);
  useEffect(() => { const t = setTimeout(() => api.get(`/admin/activity?action=${encodeURIComponent(f.action)}&email=${encodeURIComponent(f.email)}`).then((x) => setLogs(x.data)), 250); return () => clearTimeout(t); }, [f]);
  if (!r) return <div className="h-64 rounded-2xl bg-muted animate-pulse" />;
  return (
    <div data-testid="admin-reports-page">
      <PageTitle title="Reports & activity" copy="Last 30 days across the platform." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        <Stat label="AI credits used" value={r.credits_used.toLocaleString()} color="#7c3aed" testId="report-credits-used" />
        <Stat label="Credits saved by reuse" value={r.credits_saved.toLocaleString()} color="#10b981" testId="report-credits-saved" />
        <Stat label="Content published" value={r.published} color="#4f46e5" />
        <Stat label="Tracked clicks" value={r.clicks} color="#06b6d4" />
        <Stat label="Leads captured" value={r.leads.reduce((a, b) => a + b.count, 0)} color="#db2777" />
      </div>
      <div className="mt-6 grid lg:grid-cols-2 gap-5">
        <Chart title="Sign-ups per day" data={r.signups} x="day" y="count" color="#4f46e5" />
        <Chart title="Logins per day" data={r.logins} x="day" y="count" color="#06b6d4" />
        <Chart title="AI credits by task" data={r.usage_by_task} x="task" y="credits" color="#7c3aed" />
        <Chart title="Top companies by AI usage" data={r.usage_by_company} x="company" y="credits" color="#f59e0b" />
        <Chart title="Leads per day" data={r.leads} x="day" y="count" color="#db2777" />
        <Chart title="Revenue by month" data={r.revenue} x="period" y="total" color="#10b981" />
      </div>
      <h3 className="mt-10 mb-4 text-xl font-semibold">Activity log</h3>
      <div className="flex gap-3 mb-4"><Input placeholder="Filter action (e.g. auth.login, ai.)" value={f.action} onChange={(e) => setF({ ...f, action: e.target.value })} className="max-w-xs" data-testid="activity-action-filter" />
        <Input placeholder="Filter user email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="max-w-xs" data-testid="activity-email-filter" /></div>
      <div className="card-box overflow-x-auto">
        <Table data-testid="activity-table">
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
          <TableBody>{logs.map((l) => (
            <TableRow key={l.id}><TableCell className="text-xs whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</TableCell><TableCell className="text-xs">{l.user_email}</TableCell><TableCell className="font-mono text-xs">{l.action}</TableCell>
              <TableCell className="text-xs max-w-[320px] truncate">{l.entity} {Object.keys(l.details || {}).length ? JSON.stringify(l.details) : ""}</TableCell></TableRow>))}</TableBody>
        </Table>
      </div>
    </div>
  );
}
